document.addEventListener("DOMContentLoaded", () => {
$(document).ready(() => {
window._efForm && window._efForm(); 
const detectOutOfBounds = () => {
    $(".ringbuilder-diamonds__advanced__filter").each(function(){
        const dropdown = $(this).find(".ringbuilder-diamonds__advanced__filter__dropdown");
        if(dropdown.offset().left + dropdown.outerWidth(true) > $(window).width()) return $(this).addClass("to-right");
        $(this).removeClass("to-right");
    });
}
let currentFilter = 1;
let exchange_rates;
let cursor = null;

function formatPrice(price) {
    // Convert the input to a number if it's a string
    const numericPrice = typeof price === "string" ? parseFloat(price.replace(/[^0-9.-]+/g, "")) : price;
    // Ensure the price is a number and format it with commas and two decimal places
    return numericPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

    const initMag360 = () => {
        mtOnDomReady(function() {
          jQuery('.MagicToolboxSlide[data-slide-id!="spin"] img').each(function(){
            var imageObj = new Image();
            imageObj.src = jQuery(this).attr('src');
          })
          jQuery('.MagicToolboxSelectorsContainer a[data-slide-id]').on('click',function(e) {
            jQuery('.MagicToolboxContainer .MagicToolboxSlide').removeClass('active-magic-slide');
            jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"]').addClass('active-magic-slide');
            jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector');
            jQuery(this).addClass('active-magic-selector');
            e.preventDefault();
          });
        //   mtInitVariants();
    
            jQuery('.MagicToolboxSlide img').each(function(){
            })           
        });
    
        if (Magic360.options.rows>1) {
            var $elm = document.querySelector('.Magic360');
            if ($elm) {
              var $attr = $elm.getAttribute('data-magic360-options');
              $elm.setAttribute('data-magic360-options', $attr.replace(/columns *: *[0-9]{1,};/gmi,'') )
            }
        }    
    
        Magic360.start();
    
    }
        
    initMag360();

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        document.body.classList.add('safari');
    }

    let hoverDot;
    let hoverSlider;
    let hoverCallback;

    let TYPE_OF_DIAMOND;

    const type_tags = [];

    tags.forEach(tag => {
        if(tag == "lab"){
            type_tags.push("lab");
        } else if(tag == "nat"){
            type_tags.push("nat");
        }
    })

    if(type_tags.includes("nat")){
        $(".ringbuilder-diamonds__tab").removeClass("active disabled");
        $(".ringbuilder-diamonds__tab:last-child").addClass("active");
        TYPE_OF_DIAMOND = "nat";
    }
    if(type_tags.includes("lab")){
        $(".ringbuilder-diamonds__tab").removeClass("active disabled");
        $(".ringbuilder-diamonds__tab:first-child").addClass("active");
        TYPE_OF_DIAMOND = "lab";
    }
    if(!type_tags.includes("lab")){
        $(".ringbuilder-diamonds__tab:first-child").addClass("disabled");
    }
    if(!type_tags.includes("nat")){
        $(".ringbuilder-diamonds__tab:last-child").addClass("disabled");
    }

    let scroll_lock = false;

    $(".ringbuilder-diamonds__tab").on("click", async function(){
        if(!$(this).hasClass("disabled")){
            const type = $(this).attr("data-type");
            if(type == "nat"){
                $(".ringbuilder-diamonds__tab").removeClass("active disabled");
                $(".ringbuilder-diamonds__tab:last-child").addClass("active");
                TYPE_OF_DIAMOND = "nat";
            }
            else if(type == "lab"){
                $(".ringbuilder-diamonds__tab").removeClass("active disabled");
                $(".ringbuilder-diamonds__tab:first-child").addClass("active");
                TYPE_OF_DIAMOND = "lab";
            }
            await getPriceRange(JSON.stringify(default_body));
            $(".ringbuilder__diamonds").html("");
            $(".ringbuilder-tab__diamond").attr('data-offset', 0);
            scroll_lock = true;
            useFilters();
        }
    });

    // let ALLOWED_SHAPES = tags.filter(tag => tag.includes("_shape")).map(tag => tag.replace("_shape",""));

    // console.log(ALLOWED_SHAPES);

    // const all_shapes_present = $(".ringbuilder__shape:not(.disabled)").length > 1;

    // console.log($(".ringbuilder__shape:not(.disabled)").length);
    // console.log(all_shapes_present);
    

    $(".ringbuilder__shape").each(function(){
        if(ALLOWED_SHAPES.includes($(this).attr("data-shape").toLowerCase().trim())) 
        {
            $(this).removeClass("disabled");
            $(this).addClass("active")
        }
        else $(this).addClass("disabled")
    });

    const more_then_one_shape = $(".ringbuilder__shape:not(.disabled)").length > 1;

    if(more_then_one_shape){
        $(".ringbuilder__shape.active").each(function(){
            $(this).removeClass("active");
        });
    }
    
    $(document).on("mousemove touchmove", (e) => {
        if(hoverDot && hoverSlider && hoverCallback){
            e.stopPropagation();
            const rect = hoverSlider.offset();
            let x = 0;
            if(e.touches) {
                x = e.touches[0].clientX - rect.left;
            }
            else {
                x = e.clientX - rect.left;
            }
            hoverCallback(x);
        }
    });
    
    const handleMouseEvents = (dot, slider, callback) => {
        dot.on("mousedown touchstart", (e) => {
            hoverDot = dot;
            hoverSlider = slider;
            hoverCallback = callback;
            $("body").css({"user-select":"none"});
        })
        $("body").on("mouseup touchend", (e) => {
            if(hoverDot && hoverSlider && hoverCallback && $(".ringbuilder-tab__diamond").hasClass("loaded") && $(window).width() >= 800) {
                e.stopPropagation();
                $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                $(".ringbuilder-tab__diamond").removeClass("loaded");
                $(".ringbuilder__diamonds").html("");
                useFilters();
            }
            hoverDot = undefined;
            hoverSlider = undefined;
            hoverCallback = undefined;
            $(".ringbuilder__slider__dragging").removeClass("ringbuilder__slider__dragging");
            $("body").css({"user-select":"auto"});
        })
    }

    $(".ringbuilder__price__selects select, .ringbuilder__carat__selects select").on("change", function(){
        if($(".ringbuilder-tab__diamond").hasClass("loaded") && !hoverDot && !hoverCallback && !hoverSlider && $(window).width() >= 800){
            $(".ringbuilder-tab__diamond").attr('data-offset', 0);
            $(".ringbuilder-tab__diamond").removeClass("loaded");
            $(".ringbuilder__diamonds").html("");
            useFilters();
        }
    });
    $(".ringbuilder__shape").on("click", function(){
        if(!$(this).hasClass("disabled")){
            $(this).toggleClass("active");
            if($(window).width() >= 800){
                $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                $(".ringbuilder-tab__diamond").removeClass("loaded");
                $(".ringbuilder__diamonds").html("");
                useFilters();
            }
        }
    });

    function updateSliders(){
        $(".ringbuilder__slider--sectioned").each(function(){
                const parent_width = $(this).find(".ringbuilder__slider__sections").width();
                const sections = $(this).find(".ringbuilder__slider__sections div").toArray();
                const parent_percent = parent_width / 100;
                const section_width = parent_width / sections.length;
                const section_percent = section_width / parent_percent;
                const bounds = [];
                for (let i = 0; i < sections.length; i++) {
                    bounds.push((i+1) * section_percent);
                }
                $(this).attr('data-bounds', JSON.stringify(bounds));
        });
    }


    $(".final-stage__item__change--ring").on("click", function(){
        console.log("Changing the ring");
        // window.location.href = `/collections/${window.location.href.split("collections/")[1].split("/")[0]}`;
        window.location.href = $(".change-ring a").attr("href");
    });
    
    $(document).on("click", ".ringbuilder-tab__ring .ringbuilder-back", function(){
        if($(this).closest(".ringbuilder-tab__ring").hasClass("final")){
            $(".ringbuilder-navigation__step.active").removeClass("active");
            $(".ringbuilder-navigation__step--diamond").addClass("active");
            $(".ringbuilder_diamond_description").removeClass("active");
            $(".ringbuilder-tab__diamond-one").show();
            $(".ringbuilder-tab__diamond").hide();
            $(".ringbuilder-tab__ring").hide();
            $(".ringbuilder-tab__ring").removeClass("final");
    
            $(window).scrollTop($(".ringbuilder-navigation").offset().top - 20);
            if($(window).width() < 800){
                $(window).scrollTop(0);
            }
        } else {
            window.location.href = `/collections/${window.location.href.split("collections/")[1].split("/")[0]}`;
        }
    });

    $(".ringbuilder-tab__diamond-one .ringbuilder-back").on("click", function(){
        $(".ringbuilder-navigation__step.active").removeClass("active");
        $(".ringbuilder-navigation__step--diamond").addClass("active").addClass("unmarked");
        $(".ringbuilder_diamond_descrion").addClass("active");
        $(".section-complete-the-set-ringbuilder").addClass("hidden");
        $(".ringbuilder-tab__diamond-one").hide();
        $(".ringbuilder-tab__diamond").show();
        $(".ringbuilder-tab__ring").hide();
        $(".ringbuilder-tab__ring").removeClass("final");
    });

    $(".ringbuilder__add-ring").on("click", function(){
        $(".ringbuilder__popup").fadeIn(300);
    });
    
    $(".ringbuilder__popup__close").on("click", function(){
        $(".ringbuilder__popup").fadeOut(300);
    });

    $(".ringbuilder__popup__button").on("click", function(){
        $(".ringbuilder__popup").fadeOut(300, function(){
            if($(window).width() < 800){
                $(window).scrollTop(0);
            }
            const img = $(".ringbuilder-col.alpha .magic_holder .MagicToolboxSelectorsContainer a").eq(1).find("img").clone();
            const name = $(".product_name").text();
            const type = $(".swatch__header").text();
            const price = $($(".ringbuilder-cols .current_price .money")[0]).text()
            $(".ringbuilder-navigation__step--ring .ringbuilder-navigation__product__image").html(img);
            $(".ringbuilder-navigation__step--ring .ringbuilder-navigation__product__name").text(name);
            $(".ringbuilder-navigation__step--ring .ringbuilder-navigation__product__description").text(type);
            $(".ringbuilder-navigation__step--ring .ringbuilder-navigation__product__price").text(price);

            $(".ringbuilder-navigation__step.active").removeClass("active");
            $(".ringbuilder-navigation__step--ring").addClass("done");
            $(".ringbuilder-navigation__step--diamond").addClass("active");
            $(".section-complete-the-set-ringbuilder").addClass("hidden");
            $(".ringbuilder-tab__ring").hide();
            $(".ringbuilder-tab__diamond").show(0, () => {
                updateSliders();
            });
        });
    });

    $(".view-ring").on("click", function(){
        $(".ringbuilder-navigation__step.active").removeClass("active");
        $(".ringbuilder-navigation__step--ring").addClass("active");
        $(".ringbuilder-tab__diamond-one").hide();
        $(".ringbuilder-tab__diamond").hide();
        $(".section-complete-the-set-ringbuilder").removeClass("hidden");
        $(".ringbuilder_main_description").removeClass("hidden");
        $(".ringbuilder_diamond_description").removeClass("active");
        $(".ringbuilder-tab__ring").show();
        $(".ringbuilder-tab__ring").removeClass("final");
        if($(window).width() < 800){
            $(window).scrollTop(0);
        }
    });
    $(".view-diamond").on("click", function(){
        $(".ringbuilder-navigation__step.active").removeClass("active");
        $(".ringbuilder-navigation__step--diamond").addClass("active");
        $(".section-complete-the-set-ringbuilder").removeClass("hidden");
        $(".ringbuilder_diamond_description").addClass("active");
        $(".ringbuilder-tab__diamond-one").show();
        $(".ringbuilder-tab__diamond").hide();
        $(".ringbuilder-tab__ring").hide();
        $(".ringbuilder-tab__ring").removeClass("final");

        $(window).scrollTop($(".ringbuilder-navigation").offset().top - 20);
        if($(window).width() < 800){
            $(window).scrollTop(0);
        }
    });
    $(".change-diamond, .final-stage__item__change--diamond, .ringbuilder__dOne-back").on("click", function(){
        $(".ringbuilder-navigation__step.active").removeClass("active");
        $(".ringbuilder-navigation__step--diamond").addClass("active").addClass("unmarked").removeClass("step__hover");
        $(".ringbuilder-tab__diamond-one").hide();
        $(".ringbuilder-tab__diamond").show();
        $(".ringbuilder-tab__ring").hide();
        $(".ringbuilder-tab__ring").removeClass("final");
        $(".section-complete-the-set-ringbuilder").addClass("hidden");
        if($(window).width() < 800){
            $(window).scrollTop(0);
        }
    });

    // DELETE AFTER DONE

    // $(document).on("click", function(e){
    //     const parent = $(e.target).closest(".ringbuilder-diamonds__advanced__filter");
    //     $(".ringbuilder-diamonds__advanced__filter.active").each(function(){
    //         if(!$(this).is(parent)) $(this).removeClass("active");
    //     });
    //     if($('.ringbuilder__select__dropdown').hasClass("active")){
    //         $(".ringbuilder__select__dropdown").removeClass("active");
    //         $(".ringbuilder__select__list").slideUp(200);
    //     }
    // });
    $(".ringbuilder-diamonds__advanced__button").on("click", function(){
        $(this).toggleClass("active");
        $(".ringbuilder-diamonds__advanced__filters").toggleClass("active");
    })
    $(".ringbuilder-diamonds__advanced__filter__meta").on("click", function(){
        if($(window).width() < 800){
          const parent = $(this).closest(".ringbuilder-diamonds__advanced__filter");
          $(".ringbuilder-diamonds__advanced__filter.active").each(function(){
              if(!$(this).is(parent)) $(this).removeClass("active");
          });
          $(this).closest(".ringbuilder-diamonds__advanced__filter").toggleClass("active");
          currentFilter = $(".ringbuilder-diamonds__advanced__filter.active .ringbuilder-diamonds__advanced__filter__dropdown");
          detectOutOfBounds();
          $(`.ringbuilder-diamonds__blured-bg`).fadeIn(200, updateSliders);
          $("body").css("overflow", "hidden");    
        }
    })
    $(".ringbuilder-diamonds__advanced__filter").on("mouseenter", function(){
        if($(window).width() >= 800){
          const parent = $(this);
          $(".ringbuilder-diamonds__advanced__filter.active").each(function(){
              if(!$(this).is(parent)) $(this).removeClass("active");
          });
          $(this).addClass("active");
          currentFilter = $(".ringbuilder-diamonds__advanced__filter.active .ringbuilder-diamonds__advanced__filter__dropdown");
          detectOutOfBounds();
          updateSliders();
        }
    });
    $(".ringbuilder-diamonds__advanced__filter").on("mouseleave", function(){
        if($(window).width() >= 800){
          const parent = $(this);
          $(".ringbuilder-diamonds__advanced__filter.active").each(function(){
              if(!$(this).is(parent)) $(this).removeClass("active");
          });
          $(this).removeClass("active");
          currentFilter = $(".ringbuilder-diamonds__advanced__filter.active .ringbuilder-diamonds__advanced__filter__dropdown");
          detectOutOfBounds();
          updateSliders();
        }
    });
    $(".ringbuilder-diamonds__advanced__filter__checkbox label").on("click", function(){
        $(this).prev().click();
    });
    $(".ringbuilder-diamonds__advanced__filter__checkbox input").on("change", function(){
        const parent = $(this).closest(".ringbuilder-diamonds__advanced__filter__checkbox");
        parent.toggleClass("active");
        if($(window).width() >= 800){
            $(".ringbuilder-tab__diamond").attr('data-offset', 0);
            $(".ringbuilder-tab__diamond").removeClass("loaded");
            $(".ringbuilder__diamonds").html("");
            useFilters();
        }
    });
    $(".ringbuilder__slider__input").each(function(){
        const parent = $(this);
        $(this).find(".number__arrow.up").on("click", function(){
            const input = parent.find("input[type=number]");
            let future_val = (parseFloat(input.val()) + parseFloat(input.attr('step'))).toFixed(2);
            if(parseFloat(future_val) > parseFloat(input.attr('max')).toFixed(2)) future_val = parseFloat(input.attr('max')).toFixed(2);
            if(input.length) input.val(future_val) && input.trigger("keyup");
        });
        $(this).find(".number__arrow.down").on("click", function(){
            const input = parent.find("input[type=number]");
            let future_val = (parseFloat(input.val()) - parseFloat(input.attr('step'))).toFixed(2);
            if(parseFloat(future_val) < parseFloat(input.attr('min')).toFixed(2)) future_val = parseFloat(input.attr('min')).toFixed(2);
            if(input.length) input.val(future_val) && input.trigger("keyup");
        });
    });

    $(".ringbuilder__slider:not(.ringbuilder__slider--sectioned, .ringbuilder__slider__price)").each(function(){
        const step = parseFloat($(this).next().find("input").attr("step")).toFixed(2);
        const max = parseFloat($(this).next().find("input").attr('max')).toFixed(2);
        const min = parseFloat($(this).next().find("input").attr('min')).toFixed(2);
        const list = [];
        const percent = 100 / ((max - min) / step);
        const percents = [];
        for (let i = 0; i < (max - min) / step; i++) {
            percents.push(i * percent);
            list.push((parseFloat(min) + (i*parseFloat(step))).toFixed(2));
        }
        percents.push(100);
        list.push((parseFloat(min) + ((percents.length - 1)*parseFloat(step))).toFixed(2))

        const closest_min = percents.reduce(function(prev, curr) {
            return (Math.abs(curr - 0) < Math.abs(prev - 0) ? curr : prev);
        });
        const closest_max = percents.reduce(function(prev, curr) {
            return (Math.abs(curr - 100) < Math.abs(prev - 100) ? curr : prev);
        });
        const index_of_closest_min = percents.indexOf(closest_min);
        const value_of_closest_min = list[index_of_closest_min];
        const index_of_closest_max = percents.indexOf(closest_max);
        const value_of_closest_max = list[index_of_closest_max];

        $(this).next().find(".ringbuilder__min").val(value_of_closest_min).change();
        $(this).next().find(".ringbuilder__max").val(value_of_closest_max).change();

        $(this).on("click", function(e){
            e.stopPropagation();
            const rect = $(this).offset();
            let x = 0;
            if(e.touches) {
                x = e.touches[0].clientX - rect.left;
            }
            else {
                x = e.clientX - rect.left;
            }
            const w_percent = $(this).width() / 100;
            const click_pos = x / w_percent;

            const left_dot = parseFloat($(this).find(".ringbuilder__slider__inner").css("left")) / w_percent;
            const right_dot = ($(this).width() - parseFloat($(this).find(".ringbuilder__slider__inner").css("right"))) / w_percent;

            const middle_point = left_dot + (right_dot - left_dot) / 2;
            if(middle_point <= click_pos){ // Right is closer
                const closest = percents.reduce(function(prev, curr) {
                    return (Math.abs(curr - click_pos) < Math.abs(prev - click_pos) ? curr : prev);
                });
                const index_of_closest = percents.indexOf(closest);
                const value_of_closest = list[index_of_closest];
                $(this).next().find(".ringbuilder__max").val(value_of_closest).change();
                $(this).find(".ringbuilder__slider__inner").css("right", `${100 - click_pos}%`);
                
            } else { // Left is closer
                const closest = percents.reduce(function(prev, curr) {
                    return (Math.abs(curr - click_pos) < Math.abs(prev - click_pos) ? curr : prev);
                });
                const index_of_closest = percents.indexOf(closest);
                const value_of_closest = list[index_of_closest];
                $(this).next().find(".ringbuilder__min").val(value_of_closest).change();
                $(this).find(".ringbuilder__slider__inner").css("left", `${click_pos}%`);
            }
            if($(window).width() > 800) {
                $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                $(".ringbuilder-tab__diamond").removeClass("loaded");
                $(".ringbuilder__diamonds").html("");
                useFilters();
            }
        });

        handleMouseEvents($(this).find(".ringbuilder__slider__before"), $(this), (x) => {
            $(this).addClass("ringbuilder__slider__dragging");
            const w_percent = $(this).width() / 100;
            const left = x / w_percent;
            let output;
            let overlaping = false;
            if(left <= 0) 
                output = 0;
            else if(x >= parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)){
                output = (parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)) / w_percent;
                if(x >= parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)){
                    overlaping = (parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)) / w_percent;
                } else overlaping = left;
            }
            else
                output = left;

            const closest = percents.reduce(function(prev, curr) {
                return overlaping ? (Math.abs(curr - overlaping) < Math.abs(prev - overlaping) ? curr : prev):
                (Math.abs(curr - output) < Math.abs(prev - output) ? curr : prev);
            });
            const index_of_closest = percents.indexOf(closest);
            const value_of_closest = list[index_of_closest];
            $(this).next().find(".ringbuilder__min").val(value_of_closest).change();
            $(this).find(".ringbuilder__slider__inner").css("left", `${output}%`);
        });

        handleMouseEvents($(this).find(".ringbuilder__slider__after"), $(this), (x) => {
            $(this).addClass("ringbuilder__slider__dragging");
            const w_percent = $(this).width() / 100;
            const left = x / w_percent;
            const right = 100 - left;
            let output;
            let overlaping = false;
            if(right <= 0) 
                output = 0;
            else if(right * w_percent > parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)){
                output = (parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)) / w_percent;
                if(right * w_percent > parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)){
                    overlaping = (parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)) / w_percent;
                } else overlaping = right;
            }
            else 
                output = right;

            const closest = percents.reduce(function(prev, curr) {
                return overlaping ? (Math.abs(curr - (100 - overlaping)) < Math.abs(prev - (100 - overlaping)) ? curr : prev):
                (Math.abs(curr - (100 - output)) < Math.abs(prev - (100 - output)) ? curr : prev);
            });
            const index_of_closest = percents.indexOf(closest);
            const value_of_closest = list[index_of_closest];
            $(this).next().find(".ringbuilder__max").val(value_of_closest).change();
            $(this).find(".ringbuilder__slider__inner").css("right", `${output}%`);
        });

        const slider = $(this);
        $(this).next().find(".ringbuilder__min").on("change keyup", function(e){
            const index_of_percent = list.indexOf(parseFloat($(this).val()).toFixed(2));
            const value_of_percent = percents[index_of_percent];
            if(value_of_percent * ($(slider).width() / 100) < $(slider).width() - 30){
                $(slider).find(".ringbuilder__slider__inner").css("left", `${value_of_percent}%`);
            } else {
                $(slider).find(".ringbuilder__slider__inner").css("left", `${$(slider).find(".ringbuilder__slider").width() - 30}px`);
            }
        });
        
        $(this).next().find(".ringbuilder__max").on("change keyup", function(e){
            const index_of_percent = list.indexOf(parseFloat($(this).val()).toFixed(2));
            const value_of_percent = percents[index_of_percent];
            $(slider).find(".ringbuilder__slider__inner").css("right", `${100 - value_of_percent}%`);
        });

        $(this).next().find(".ringbuilder__min, .ringbuilder__max").on("keyup", function(e){
            $(".ringbuilder-tab__diamond").attr('data-offset', 0);
            $(".ringbuilder-tab__diamond").removeClass("loaded");
            $(".ringbuilder__diamonds").html("");
            useFilters();
        });

    });

    // NEEDS REFACTORING
    const initRegularSliders = (substr) => {
        const carat_percents = 100 / $(".ringbuilder__"+substr+"__min option").length;
        const carat_list = $(".ringbuilder__"+substr+"__min option").toArray().map(item => item.value);
        const percents = [];
        for (let i = 0; i < $(".ringbuilder__"+substr+"__min option").length; i++) {
            percents.push(i * carat_percents);
        }

        const closest_min = percents.reduce(function(prev, curr) {
            return (Math.abs(curr - 0) < Math.abs(prev - 0) ? curr : prev);
        });
        const closest_max = percents.reduce(function(prev, curr) {
            return (Math.abs(curr - 100) < Math.abs(prev - 100) ? curr : prev);
        });
        const index_of_closest_min = percents.indexOf(closest_min);
        const value_of_closest_min = carat_list[index_of_closest_min];
        const index_of_closest_max = percents.indexOf(closest_max);
        const value_of_closest_max = carat_list[index_of_closest_max];

        $(".ringbuilder__"+substr+"__min").val(value_of_closest_min).change();
        $(".ringbuilder__"+substr+"__max").val(value_of_closest_max).change();

        $(".ringbuilder__"+substr+"__slider").on("click", function(e){
            e.stopPropagation();
            const rect = $(this).offset();
            let x = 0;
            if(e.touches) {
                x = e.touches[0].clientX - rect.left;
            }
            else {
                x = e.clientX - rect.left;
            }
            const w_percent = $(this).width() / 100;
            const click_pos = x / w_percent;

            const left_dot = parseFloat($(this).find(".ringbuilder__"+substr+"__slider__inner").css("left")) / w_percent;
            const right_dot = ($(this).width() - parseFloat($(this).find(".ringbuilder__"+substr+"__slider__inner").css("right"))) / w_percent;

            const middle_point = left_dot + (right_dot - left_dot) / 2;
            if(middle_point <= click_pos){ // Right is closer
                const closest = percents.reduce(function(prev, curr) {
                    return (Math.abs(curr - click_pos) < Math.abs(prev - click_pos) ? curr : prev);
                });
                const index_of_closest = percents.indexOf(closest);
                const value_of_closest = carat_list[index_of_closest];
                $(this).next().find(".ringbuilder__"+substr+"__max").val(value_of_closest).change();
                $(this).find(".ringbuilder__"+substr+"__slider__inner").css("right", `${100 - click_pos}%`);
                
            } else { // Left is closer
                const closest = percents.reduce(function(prev, curr) {
                    return (Math.abs(curr - click_pos) < Math.abs(prev - click_pos) ? curr : prev);
                });
                const index_of_closest = percents.indexOf(closest);
                const value_of_closest = carat_list[index_of_closest];
                $(this).next().find(".ringbuilder__"+substr+"__min").val(value_of_closest).change();
                $(this).find(".ringbuilder__"+substr+"__slider__inner").css("left", `${click_pos}%`);
            }
            if($(window).width() > 800) {
                $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                $(".ringbuilder-tab__diamond").removeClass("loaded");
                $(".ringbuilder__diamonds").html("");
                useFilters();
            }
        });

        handleMouseEvents($(".ringbuilder__"+substr+"__slider__before"), $(".ringbuilder__"+substr+"__slider"), (x) => {
            $(".ringbuilder__"+substr+"__slider").addClass("ringbuilder__slider__dragging");
            const w_percent = $(".ringbuilder__"+substr+"__slider").width() / 100;
            const left = x / w_percent;
            let output;
            let overlaping = false;
            // console.log(x, w_percent, left);
            console.log(parseInt($(".ringbuilder__"+substr+"__slider__inner").css("left")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true));
            if(left <= 0){ // Limit slider left side offset to 0 so it won't go negative beyond the container's left border
                output = 0;
            } 
            else if(x >= parseInt($(".ringbuilder__"+substr+"__slider__inner").css("left")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true)){
                output = (parseInt($(".ringbuilder__"+substr+"__slider__inner").css("left")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true)) / w_percent;
                if(x >= parseInt($(".ringbuilder__"+substr+"__slider__inner").css("left")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true)){
                    overlaping = (parseInt($(".ringbuilder__"+substr+"__slider__inner").css("left")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true)) / w_percent;
                } else {
                    overlaping = left;
                }
            }
            else { // If slider left side offset is between 0 and the begining of the right dot
                output = left;
            }
            const closest = percents.reduce(function(prev, curr) {
                if(overlaping) return (Math.abs(curr - overlaping) < Math.abs(prev - overlaping) ? curr : prev);
                return (Math.abs(curr - output) < Math.abs(prev - output) ? curr : prev);
            });
            const index_of_closest = percents.indexOf(closest);
            const value_of_closest = carat_list[index_of_closest];
            $(".ringbuilder__"+substr+"__min").val(value_of_closest).change();
            $(".ringbuilder__"+substr+"__slider__inner").css("left", `${output}%`);
        });

        handleMouseEvents($(".ringbuilder__"+substr+"__slider__after"), $(".ringbuilder__"+substr+"__slider"), (x) => {
            $(".ringbuilder__"+substr+"__slider").addClass("ringbuilder__slider__dragging");
            const w_percent = $(".ringbuilder__"+substr+"__slider").width() / 100;
            const left = x / w_percent;
            const right = 100 - left;
            let output;
            let overlaping = false;
            if(right <= 0) {
                output = 0;
            }
            else if(right * w_percent >= parseInt($(".ringbuilder__"+substr+"__slider__inner").css("right")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true))
            {
                output = (parseInt($(".ringbuilder__"+substr+"__slider__inner").css("right")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true)) / w_percent;
                if(right * w_percent >= parseInt($(".ringbuilder__"+substr+"__slider__inner").css("right")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true)){
                    overlaping = (parseInt($(".ringbuilder__"+substr+"__slider__inner").css("right")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true)) / w_percent
                } else {
                    overlaping = right;
                }
            }
            // else if(right * w_percent > parseInt($(".ringbuilder__"+substr+"__slider__inner").css("right")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true) * 2)
            //     output = (parseInt($(".ringbuilder__"+substr+"__slider__inner").css("right")) + $(".ringbuilder__"+substr+"__slider__inner").outerWidth(true) - $(".ringbuilder__"+substr+"__slider__after").outerWidth(true) * 2) / w_percent;
            else {
                output = right;
            } 

            const closest = percents.reduce(function(prev, curr) {
                if(overlaping) return (Math.abs(curr - (100 - overlaping)) < Math.abs(prev - (100 - overlaping)) ? curr : prev);
                return (Math.abs(curr - (100 - output)) < Math.abs(prev - (100 - output)) ? curr : prev);
            });
            const index_of_closest = percents.indexOf(closest);
            const value_of_closest = carat_list[index_of_closest];
            $(".ringbuilder__"+substr+"__max").val(value_of_closest).change();
            $(".ringbuilder__"+substr+"__slider__inner").css("right", `${output}%`);
        });

        const slider = $(this);
        $(".ringbuilder__"+substr+"__min").on("change", function(e){
            const index_of_percent = carat_list.indexOf($(this).val())
            const value_of_percent = percents[index_of_percent];
            const dot_w = slider.find(".ringbuilder__"+substr+"__slider__dot").outerWidth(true);
            if(value_of_percent * ($(".ringbuilder__"+substr+"__slider").width() / 100) < $(".ringbuilder__"+substr+"__slider").width() - dot_w){
                $(".ringbuilder__"+substr+"__slider__inner").css("left", `${value_of_percent}%`);
            } else {
                $(".ringbuilder__"+substr+"__slider__inner").css("left", `${$(".ringbuilder__"+substr+"__slider").width() - dot_w}px`);
            }
        });
    
        $(".ringbuilder__"+substr+"__max").on("change", function(e){
            const index_of_percent = carat_list.indexOf($(this).val())
            const value_of_percent = percents[index_of_percent];
            const dot_w = slider.find(".ringbuilder__"+substr+"__slider__dot").outerWidth(true);
            if((100 - value_of_percent) * ($(".ringbuilder__"+substr+"__slider").width() / 100) < $(".ringbuilder__"+substr+"__slider").width() - dot_w){
                $(".ringbuilder__"+substr+"__slider__inner").css("right", `${100 - value_of_percent}%`);
            } else {
                $(".ringbuilder__"+substr+"__slider__inner").css("right", `${$(".ringbuilder__"+substr+"__slider").width() - dot_w}px`);
            }
            // $(".ringbuilder__"+substr+"__slider__inner").css("right", `${100 - value_of_percent}%`);
        });
    
    }

    // NEEDS REFACTORING
    initRegularSliders("carat");

    const calculateSnap = (bounds, output) => {
        let snap_position = output;
        let min_bound = 0;
        let max_bound = 100;
        if(output == 0) snap_position = 0;
        else if(output == 100) snap_position = 100;
        else{
            bounds.forEach((item) => {
                if(item < output && item > min_bound) min_bound = item;
                if(item > output && item < max_bound) max_bound = item;
            })
            const middle_point = (max_bound - min_bound) / 2;
            if(output < min_bound + middle_point) snap_position = min_bound;
            else if(output > min_bound + middle_point) snap_position = max_bound;
            else snap_position = output;
        }
        return {snap_position, index: bounds.indexOf(snap_position) + 1};
    }

    const calculateActiveSections = (sections, min, max) => {
        sections.removeClass("selected");
        sections.each(function(id){
            if(id > min && id < max) $(this).addClass("selected");
            if(id == min) $(this).addClass("selected");
            if(id == max) $(this).addClass("selected");
        });
        let found_pre = false;
        let pre = 0;
        let selected = 0;
        sections.each(id => {
            if($(sections[id]).hasClass("selected")) found_pre = true;
            if(!found_pre) pre++;
            if(found_pre && $(sections[id]).hasClass("selected")) selected++;
        });
        const lines = $(sections[0]).closest(".ringbuilder__slider").find(".ringbuilder__slider__line");
        lines.removeClass("dark");
        lines.each(function(id){
            if(id + 1 < pre) $(this).addClass("dark");
            if(id > selected + pre - 1) $(this).addClass("dark");
        });
    }

    $(document).on("click", ".ringbuilder__info__button", function(e){
        e.stopPropagation();
        $(".ringbuilder_diamond_description.active .drawer__button-close").click();
        $("body").css("overflow","hidden");
        const popup_id = $(this).attr("data-id");
        const popup = $(`.ringbuilder-diamonds__popup-${popup_id}`);
        $(`.ringbuilder-diamonds__blured-bg`).fadeIn(200);  
        popup.fadeIn(200);    
        if($(window).width() <= 800){
            $(".ringbuilder-diamonds__filters__cell").fadeOut(200);
        }
        $(".ringbuilder-diamonds__advanced__filter").removeClass("active");
        $(".ringbuilder-diamonds__advanced__filter .ringbuilder-diamonds__advanced__filter__dropdown").fadeOut(200);
    });
    
    $(".ringbuilder-diamonds__popup__close").on("click", function(){
        $(".ringbuilder-diamonds__popup").fadeOut(200);
        $(".ringbuilder-diamonds__blured-bg").fadeOut(200);
        if($(".rigbuilder__size-selector").hasClass("shown")){
            $(".rigbuilder__size-selector").removeClass("shown");
        }
        $("body").css("overflow","auto");
        if($(window).width() <= 800){
            $(`.ringbuilder-diamonds__blured-bg`).fadeIn(200);
           currentFilter.fadeIn(200);
        }

      setTimeout(function() { 
         currentFilter.parent().addClass("active");  
    }, 500);

    });

    $(".ringbuilder-diamonds__popup").on("click", function(e){
        e.stopPropagation();
    });

    $(".ringbuilder__slider--sectioned").each(function(){

        let min_section = 0;
        let max_section = $(this).find(".ringbuilder__slider__section").length - 1;

        const self = $(this);

        $(this).on("click", function(e){
            e.stopPropagation();
            const rect = $(this).offset();
            let x = 0;
            if(e.touches) {
                x = e.touches[0].clientX - rect.left;
            }
            else {
                x = e.clientX - rect.left;
            }
            const w_percent = $(this).width() / 100;
            const click_pos = x / w_percent;

            const left_dot = parseFloat($(this).find(".ringbuilder__slider__inner").css("left")) / w_percent;
            const right_dot = ($(this).width() - parseFloat($(this).find(".ringbuilder__slider__inner").css("right"))) / w_percent;

            const middle_point = left_dot + (right_dot - left_dot) / 2;

            const bounds = JSON.parse($(this).attr("data-bounds"));
            const {snap_position, index} = calculateSnap(bounds, click_pos);
            
            if(middle_point <= click_pos){ // Right is closer

                max_section = index - 1;

                const selected = bounds.indexOf(snap_position);
                const options = $(this).next();
                options.attr("data-end", selected);
    
                options.find(".ringbuilder__slider__option").removeClass("selected");
                options.find(".ringbuilder__slider__option").each(function(i){
                    if(i >= options.attr("data-start") || !options.attr("data-start")){
                        $(this).addClass("selected");
                    }
                    if(i > selected){
                        $(this).removeClass("selected");
                    }
                });
        
                calculateActiveSections($(this).find(".ringbuilder__slider__section"), min_section, max_section);
                $(this).find(".ringbuilder__slider__inner").css("right", `${100 - snap_position}%`);
                
            } else { // Left is closer
                
                min_section = index;

                const selected = bounds.indexOf(snap_position) + 1;
                const options = $(this).next();
                options.attr("data-start", selected);

                options.find(".ringbuilder__slider__option").removeClass("selected");
                options.find(".ringbuilder__slider__option").each(function(i){
                    if(i >= selected){
                        if(i <= options.attr("data-end") && options.attr("data-end")){
                            $(this).addClass("selected");
                        } else if(!options.attr("data-end")){
                            $(this).addClass("selected");
                        }
                    }
                });
                
                calculateActiveSections($(this).find(".ringbuilder__slider__section"), min_section, max_section);
                $(this).find(".ringbuilder__slider__inner").css("left", `${snap_position}%`);
            }
            if($(window).width() > 800) {
                $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                $(".ringbuilder-tab__diamond").removeClass("loaded");
                $(".ringbuilder__diamonds").html("");
                useFilters();
            }
        });

        handleMouseEvents($(this).find(".ringbuilder__slider__before"), $(this), (x) => {
            $(this).addClass("ringbuilder__slider__dragging");
            const w_percent = $(this).width() / 100;
            const left = x / w_percent;
            // console.log(left);
            // console.log(parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true) * 2);
            let output;
            if(left <= 0) 
                output = 0;
            else if(x >= parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__section").outerWidth(true) / 2){
                output = (parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__section").outerWidth(true)) / w_percent;
            } else
            output = left;
            
            const bounds = JSON.parse($(this).attr("data-bounds"));
            
            const {snap_position, index} = calculateSnap(bounds, output);

            min_section = index;

            const selected = bounds.indexOf(snap_position) + 1;
            const options = $(this).next();
            options.attr("data-start", selected);

            options.find(".ringbuilder__slider__option").removeClass("selected");
            options.find(".ringbuilder__slider__option").each(function(i){
                if(i >= selected){
                    if(i <= options.attr("data-end") && options.attr("data-end")){
                        $(this).addClass("selected");
                    } else if(!options.attr("data-end")){
                        $(this).addClass("selected");
                    }
                }
            });

            max_section = $(this).next(".ringbuilder__slider__options").attr("data-end") ? parseInt($(this).next(".ringbuilder__slider__options").attr("data-end")) : bounds.length - 1;
            
            calculateActiveSections($(this).find(".ringbuilder__slider__section"), min_section, max_section);
            $(this).find(".ringbuilder__slider__inner").css("left", `${snap_position}%`);
        });

        handleMouseEvents($(this).find(".ringbuilder__slider__after"), $(this), (x) => {
            $(this).addClass("ringbuilder__slider__dragging");
            const w_percent = $(this).width() / 100;
            const left = x / w_percent;
            const right = 100 - left;
            if(right <= 0) 
                output = 0;
            else if(right * w_percent > parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__section").outerWidth(true) / 2)
                output = (parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__section").outerWidth(true)) / w_percent;
            else 
                output = right;

            const bounds = JSON.parse($(this).attr("data-bounds"));

            const {snap_position, index} = calculateSnap(bounds, 100 - output);
            max_section = index - 1;
            if(max_section == -1) max_section = bounds.length - 1;

            const selected = bounds.indexOf(snap_position);
            const options = $(this).next();
            options.attr("data-end", selected);

            options.find(".ringbuilder__slider__option").removeClass("selected");
            options.find(".ringbuilder__slider__option").each(function(i){
                if(i >= options.attr("data-start") || !options.attr("data-start")){
                    $(this).addClass("selected");
                }
                if(i > selected){
                    $(this).removeClass("selected");
                }
            });
    
            min_section = $(this).next(".ringbuilder__slider__options").attr("data-start") ? parseInt($(this).next(".ringbuilder__slider__options").attr("data-start")) : 0;

            calculateActiveSections($(this).find(".ringbuilder__slider__section"), min_section, max_section);
            $(this).find(".ringbuilder__slider__inner").css("right", `${100 - snap_position}%`);
        });

    });

    

    const getPriceRange = async (body) => {

        const json = {min: 0, max: 7000000};

        const zones = [
            {
                inc: 50,
                amount: 24
            },
            {
                inc: 100,
                amount: 108
            },
            {
                inc: 500,
                amount: 24
            },
            {
                inc: 1000,
                amount: 16
            },
            {
                inc: 5000,
                amount: 12
            },
            {
                inc: 50000,
                amount: 8
            },
            {
                inc: 100000,
                amount: 5
            },
            {
                inc: 1000000,
                amount: 1000
            }
        ]

        console.log(exchange_rates);

        $(".ringbuilder__price__min, .ringbuilder__price__max").attr("min", json.min).attr("max", json.max);
        $(".ringbuilder__price__min").val(json.min);
        $(".ringbuilder__price__max").val(json.max);

        $(".ringbuilder__slider__inner").css({left: 0, right: 0});

        $(".ringbuilder__slider__price").each(function(){
            // const step = parseFloat($(this).next().find("input").attr("step")).toFixed(2);
            const max = parseFloat($(this).next().find("select").attr('max')).toFixed(2);
            const min = parseFloat($(this).next().find("select").attr('min')).toFixed(2);
            const list = [];
            const percents = [];

            let curr_val = min;
            let abort = false;
            zones.forEach(zone => {
                for(let i = 0; i < zone.amount; i++){
                    if(!abort){
                        if((parseFloat(curr_val) + (zone.inc * i)) > parseFloat(max)){
                            list.push(parseFloat(parseFloat(max).toFixed(2)));
                            abort = true;
                        } else list.push(parseFloat((parseFloat(curr_val) + (zone.inc * i)).toFixed(2)));
                    }
                }
                curr_val = list[list.length - 1];
            });

            const percent = 100 / list.length;

            for(let i = 1; i <= list.length; i++){
                percents.push(i*percent);
            }

            // ZONES:
            // 50 : 50 - 1200 = 24
            // 100 : 1200 - 12000 = 108
            // 500 : 12000 - 24000 = 24
            // 1000 : 24000 - 40000 = 16
            // 5000 : 40000 - 100000 = 12
            // 50000: 100000 - 500000 = 8
            // 100000 : 500000 - 1000000 = 5
            // 1000000 : 1000000 - 5000000 = 4
            // TOTAL: 201
                 
            const closest_min = percents.reduce(function(prev, curr) {
                return (Math.abs(curr - 0) < Math.abs(prev - 0) ? curr : prev);
            });
            const closest_max = percents.reduce(function(prev, curr) {
                return (Math.abs(curr - 100) < Math.abs(prev - 100) ? curr : prev);
            });
            const index_of_closest_min = percents.indexOf(closest_min);
            const value_of_closest_min = list[index_of_closest_min];
            const index_of_closest_max = percents.indexOf(closest_max);
            const value_of_closest_max = list[index_of_closest_max];
    
            list.forEach(el => {
                $(this).next().find(".ringbuilder__min").append(`<option value="${el}">${el}</option>`);
            });
            list.forEach(el => {
                $(this).next().find(".ringbuilder__max").append(`<option value="${el}">${el}</option>`);
            });

            $(this).next().find(".ringbuilder__price__min option:first-child").prop('selected', true);
            $(this).next().find(".ringbuilder__price__max option:last-child").prop('selected', true);
    
            // $(this).next().find(".ringbuilder__min").val(value_of_closest_min).change();
            // $(this).next().find(".ringbuilder__max").val(value_of_closest_max).change();

            $(this).on("click", function(e){
                e.stopPropagation();
                const rect = $(this).offset();
                let x = 0;
                if(e.touches) {
                    x = e.touches[0].clientX - rect.left;
                }
                else {
                    x = e.clientX - rect.left;
                }
                const w_percent = $(this).width() / 100;
                const click_pos = x / w_percent;
    
                const left_dot = parseFloat($(this).find(".ringbuilder__slider__inner").css("left")) / w_percent;
                const right_dot = ($(this).width() - parseFloat($(this).find(".ringbuilder__slider__inner").css("right"))) / w_percent;
    
                const middle_point = left_dot + (right_dot - left_dot) / 2;
                if(middle_point <= click_pos){ // Right is closer
                    const closest = percents.reduce(function(prev, curr) {
                        return (Math.abs(curr - click_pos) < Math.abs(prev - click_pos) ? curr : prev);
                    });
                    const index_of_closest = percents.indexOf(closest);
                    const value_of_closest = list[index_of_closest];
                    $(this).next().find(".ringbuilder__max").val(value_of_closest).change();
                    $(this).find(".ringbuilder__slider__inner").css("right", `${100 - click_pos}%`);
                    
                } else { // Left is closer
                    const closest = percents.reduce(function(prev, curr) {
                        return (Math.abs(curr - click_pos) < Math.abs(prev - click_pos) ? curr : prev);
                    });
                    const index_of_closest = percents.indexOf(closest);
                    const value_of_closest = list[index_of_closest];
                    $(this).next().find(".ringbuilder__min").val(value_of_closest).change();
                    $(this).find(".ringbuilder__slider__inner").css("left", `${click_pos}%`);
                }
                if($(window).width() > 800) {
                    $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                    $(".ringbuilder-tab__diamond").removeClass("loaded");
                    $(".ringbuilder__diamonds").html("");
                    useFilters();
                }
                });    
    
            handleMouseEvents($(this).find(".ringbuilder__slider__before"), $(this), (x) => {
                $(this).addClass("ringbuilder__slider__dragging");
                const w_percent = $(this).width() / 100;
                const left = x / w_percent;
                let output;
                let overlaping = false;
                if(left <= 0) 
                    output = 0;
                else if(x > parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)){
                    output = (parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)) / w_percent;
                    if(x >= parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)){
                        overlaping = (parseInt($(this).find(".ringbuilder__slider__inner").css("left")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)) / w_percent;
                    } else overlaping = left;
                }
                else
                    output = left;
    
                const closest = percents.reduce(function(prev, curr) {
                    return overlaping ? (Math.abs(curr - overlaping) < Math.abs(prev - overlaping) ? curr : prev) : 
                    (Math.abs(curr - output) < Math.abs(prev - output) ? curr : prev);
                });
                const index_of_closest = percents.indexOf(closest);
                const value_of_closest = list[index_of_closest];
                $(this).next().find(".ringbuilder__min").val(value_of_closest).change();
                $(this).find(".ringbuilder__slider__inner").css("left", `${output}%`);
            });
    
            handleMouseEvents($(this).find(".ringbuilder__slider__after"), $(this), (x) => {
                $(this).addClass("ringbuilder__slider__dragging");
                const w_percent = $(this).width() / 100;
                const left = x / w_percent;
                const right = 100 - left;
                let output;
                let overlaping = false;
                if(right <= 0) 
                    output = 0;
                else if(right * w_percent > parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)){
                    output = (parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true) - $(this).find(".ringbuilder__slider__after").outerWidth(true)) / w_percent;
                    if(right * w_percent > parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)){
                        overlaping = (parseInt($(this).find(".ringbuilder__slider__inner").css("right")) + $(this).find(".ringbuilder__slider__inner").outerWidth(true)) / w_percent;
                    } else overlaping = right;
                }
                else 
                    output = right;
    
                const closest = percents.reduce(function(prev, curr) {
                    return overlaping ? (Math.abs(curr - (100 - overlaping)) < Math.abs(prev - (100 - overlaping)) ? curr : prev):
                    (Math.abs(curr - (100 - output)) < Math.abs(prev - (100 - output)) ? curr : prev);
                });
                const index_of_closest = percents.indexOf(closest);
                const value_of_closest = list[index_of_closest];
                $(this).next().find(".ringbuilder__max").val(value_of_closest).change();
                $(this).find(".ringbuilder__slider__inner").css("right", `${output}%`);
            });
    
            const slider = $(this);
            $(this).next().find(".ringbuilder__min").on("change", function(e){
                const goal = parseFloat($(this).val());
                const closest = list.reduce(function(prev, curr) {
                    return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
                });
                const dot_w = $(slider).find(".ringbuilder__slider__dot").outerWidth(true);
                const index_of_percent = list.indexOf(closest);
                const value_of_percent = percents[index_of_percent];
                if(value_of_percent * ($(slider).width() / 100) < $(slider).width() - dot_w){
                    $(slider).find(".ringbuilder__slider__inner").css("left", `${value_of_percent}%`);
                } else {
                    $(slider).find(".ringbuilder__slider__inner").css("left", `${$(slider).width() - dot_w}px`);
                }
                // if($(window).width() > 798) {
                //     $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                //     $(".ringbuilder-tab__diamond").removeClass("loaded");
                //     $(".ringbuilder__diamonds").html("");
                //     useFilters();
                // }
            });
            
            $(this).next().find(".ringbuilder__max").on("change", function(e){
                const goal = parseFloat($(this).val());
                const closest = list.reduce(function(prev, curr) {
                    return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
                });
                const dot_w = $(slider).find(".ringbuilder__slider__dot").outerWidth(true);
                const index_of_percent = list.indexOf(closest);
                const value_of_percent = percents[index_of_percent];
                if((100 - value_of_percent) * ($(slider).width() / 100) < $(slider).width() - dot_w){
                    console.log(100 - value_of_percent);
                    $(slider).find(".ringbuilder__slider__inner").css("right", `${100 - value_of_percent}%`);
                } else {
                    console.log(100 - ($(slider).width() - dot_w));
                    $(slider).find(".ringbuilder__slider__inner").css("right", `${($(slider).width() - dot_w)}px`);
                }
                // $(slider).find(".ringbuilder__slider__inner").css("right", `${100 - value_of_percent}%`);
                // if($(window).width() > 798) {
                //     $(".ringbuilder-tab__diamond").attr('data-offset', 0);
                //     $(".ringbuilder-tab__diamond").removeClass("loaded");
                //     $(".ringbuilder__diamonds").html("");
                //     useFilters();
                // }
            });
    
            // $(this).next().find(".ringbuilder__min, .ringbuilder__max").on("focusout", function(e){
            //     $(".ringbuilder-tab__diamond").attr('data-offset', 0);
            //     $(".ringbuilder-tab__diamond").removeClass("loaded");
            //     $(".ringbuilder__diamonds").html("");
            //     useFilters();
            // });
    
        })    
        // $(".ringbuilder__price__max option").eq($(".ringbuilder__price__max option").length - 1).attr("selected", true);

        // return initRegularSliders("price");
    };

    // const outputOptions = (number, increment, times, current_count, reached_end, max) => {
    //     for (let i = 0; i < times; i++) {
    //         if(!reached_end){
    //             $(".ringbuilder__price__min, .ringbuilder__price__max").append(`<option value="${number.toFixed(2)}">${number.toFixed(2)}$</option>`)
    //             if(number + increment < max){
    //                 number += increment;
    //             } else {
    //                 number = max;
    //                 reached_end = true;
    //             }
    //             current_count += 1;
    //         }
    //     }
    //     return [number, current_count, reached_end];
    // }

    const cut_names = {
        GD: "Good",
        VG: "Very Good",
        EX: "Excellent",
        ID: "Ideal"
    }

    const addDiamondAsProduct = async (diamond) => {
        const resp = await fetch("/apps/ringbuilder", {
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: diamond
            })
        });
        const json = await resp.json();        

        return json;
    }

    $(document).on("click", ".final-stage__addToCart", async function(){

        $(".final-stage__addToCart").hide();
        $(".final-stage__loader").addClass("active");

        try {
            const product_variant_id = parseInt($(".product-data").attr("data-variant"));

            // Create diamond product
    
            const resp = await addDiamondAsProduct($(".final-stage__item--diamond").attr("data-id"));

            console.log("RESPONSE", resp);
            
    
            // Add everything to cart
    
            const items = [
                {
                    id: product_variant_id,
                    quantity: 1,
                    properties: {
                        'Size': $(".final-stage__size").attr("data-size")
                    }
                },
                {
                    id: parseInt(resp.product_variant.split("gid://shopify/ProductVariant/")[1]),
                    quantity: 1
                }
            ];
    
            await $.post('/cart/add.js', {
                items
            });

            $(".final-stage__addToCart").show();
            $(".final-stage__loader").removeClass("active");

        } catch (error) {
            console.error(error);
        }

        
        // Navigate to cart
        window.location.href = "/cart";

    });

    let allowanceList = [];

    const handleAllowanceList = () => {
        allowanceList = allowanceList.filter(item => !item.done);
        allowanceList.forEach((item, i) => {
            if(i < allowanceList.length - 1){
                item.allowed = false;
                item.abortController.abort();
            }
        });
    }

    function getMetafieldValueByKey(metafields, key) {
        const metafield = metafields.find(mf => mf.key === key);
        return metafield ? metafield.value : null; // Return value if found, otherwise null
    }

    const getDiamonds = async (body, append = false) => {

        $(".ringbuilder-tab__diamond").removeClass("loaded");
        
        const controller = new AbortController();
        const signal = controller.signal;

        console.log(body);
        
        
        const unique_id = Date.now();
        const requestObject = {
            id: unique_id,
            abortController: controller,
            allowed: true,
            done: false,
            body: JSON.parse(body)
        };
        allowanceList.push(requestObject);
        handleAllowanceList();
        console.log(allowanceList);

        try {
            const resp = await fetch("/apps/ringbuilder", {
                signal,
                method: "post",
                headers: {
                    'Content-Type': 'application/json'
                },
                body
            });

            const json = await resp.json();
            const fluorescence_table = {
                NON: "None",
                FNT: "Faint",
                MED: "Medium",
                STG: "Strong",
                STN: "Strong",
                VST: "Very Strong"
            }

            console.log(json.items.items);
            
            const items_templates = json.items.items.map(item => {                 
                const data_json = {
                    type: item.diamond.certificate.labgrown ? "Labgrown" : "Natural",
                    // code: item.diamond.code,
                    shape: item.diamond.certificate.shape,
                    carat: item.diamond.certificate.carats,
                    colour: item.diamond.certificate.color,
                    clarity: item.diamond.certificate.clarity,
                    cut: item.diamond.certificate.cut,
                    polish: item.diamond.certificate.polish,
                    symmetry: item.diamond.certificate.symmetry,
                    fluorescence: fluorescence_table[item.diamond.certificate.floInt],
                    measurements: `${item.diamond.certificate.length}x${item.diamond.certificate.width}x${item.diamond.certificate.depth}mm`,
                    lwratio: Math.round(item.diamond.certificate.length/item.diamond.certificate.width * 100) / 100,
                    table: item.diamond.certificate.table,
                    depth: item.diamond.certificate.depthPercentage,
                    certificate: item.diamond.certificate.lab,
                };

                return `
                <div class="ringbuilder__diamond ringbuilder__diamond-${item.id.split("/")[1]}" data-id="${item.diamond.id}" data-json="${encodeURIComponent(JSON.stringify(data_json))}" data-code="${item.diamond.code}" data-small-name="${item.diamond.certificate.carats}ct ${item.diamond.certificate.shape[0]+item.diamond.certificate.shape.substring(1).toLowerCase()} Diamond" data-name="${item.diamond.certificate.carats}ct ${item.diamond.certificate.shape[0]+item.diamond.certificate.shape.substring(1).toLowerCase()} Cut Diamond" data-description="Cut: ${cut_names[item.diamond.certificate.cut]} | Colour: ${item.diamond.certificate.color} | Clarity: ${item.diamond.certificate.clarity}">
                    <div class="ringbuilder__diamond__half">
                        ${item.diamond.v360?.url ? `<div id="jsv-holder-${item.id}" class="jsv-holder ringbuilder__diamond__image" data-frames="${item.diamond.v360?.frame_count}" data-top="${item.diamond.v360?.top_index}" data-url="${item.diamond.v360?.url}">
                            <img id="jsv-image-${item.id}" class="jsv-image ringbuilder__diamond__image" alt="example" src="${item.diamond.v360?.url}/${item.diamond.v360?.top_index}.jpg">
                        </div>` : `<img class="ringbuilder__diamond__image" src="${$(".ringbuilder__diamonds").attr("data-img")}">`}
                    </div>
                    <div class="ringbuilder__diamond__half">
                        <div class="ringbuilder__diamond__stats">
                            <div class="ringbuilder__diamond__stat">
                                <div class="ringbuilder__diamond__stat__value">
                                    ${item.diamond.certificate.shape == "CUSHION MODIFIED" ? "CUSHION" : item.diamond.certificate.shape}
                                </div>
                                <div class="ringbuilder__diamond__stat__key">
                                    Shape
                                </div>
                            </div>
                            <div class="ringbuilder__diamond__stat">
                                <div class="ringbuilder__diamond__stat__value">
                                    ${item.diamond.certificate.carats}
                                </div>
                                <div class="ringbuilder__diamond__stat__key">
                                    Carat
                                </div>
                            </div>
                            <div class="ringbuilder__diamond__stat">
                                <div class="ringbuilder__diamond__stat__value">
                                    ${item.diamond.certificate.cut ? cut_names[item.diamond.certificate.cut] : "EX"}
                                </div>
                                <div class="ringbuilder__diamond__stat__key">
                                    Cut
                                </div>
                            </div>
                            <div class="ringbuilder__diamond__stat">
                                <div class="ringbuilder__diamond__stat__value">
                                    ${item.diamond.certificate.color}
                                </div>
                                <div class="ringbuilder__diamond__stat__key">
                                    Colour
                                </div>
                            </div>
                            <div class="ringbuilder__diamond__stat">
                                <div class="ringbuilder__diamond__stat__value">
                                    ${item.diamond.certificate.clarity}
                                </div>
                                <div class="ringbuilder__diamond__stat__key">
                                    Clarity
                                </div>
                            </div>
                            <div class="ringbuilder__diamond__stat">
                                <div class="ringbuilder__diamond__stat__value">
                                ${item.diamond.certificate.lab}
                                </div>
                                <div class="ringbuilder__diamond__stat__key">
                                    Cert.
                                </div>
                            </div>
                        </div>
                        <div class="ringbuilder__diamond__price">
                            $${formatPrice(item.markup_price / 100)} USD
                        </div>
                        <div class="ringbuilder__diamond__buttons">
                            <button class="ringbuilder__diamond__more-info btn">More info</button>
                            <button class="ringbuilder__diamond__add-diamond btn">
                                Add to ring
                            </button>
                        </div>
                    </div>
                    <div class="ringbuilder__diamond__buttons mobile">
                        <button class="ringbuilder__diamond__more-info btn">More info</button>
                        <button class="ringbuilder__diamond__add-diamond btn">
                            Add to ring
                        </button>
                    </div>
                </div>
            `});

        console.log(items_templates);
        
    
        console.log(json);
        if(allowanceList.filter(item => item.id == unique_id)[0].allowed){
            append ? $(".ringbuilder__diamonds").append(items_templates.join("")) : $(".ringbuilder__diamonds").html(items_templates.join(""));    
            
            if(json.total || json.total === 0){
              $(".ringbuilder-diamonds__total__number").text(json.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }
    
            $(".ringbuilder-tab__diamond").addClass("loaded");
        }

        } catch (error) {
            console.log(`${unique_id} process ended up with an error: ${error}`);
        }

        requestObject.done = true;    
    };


    $(document).on("scroll", function(){
        if($(".ringbuilder-navigation__step--diamond").hasClass("active") && $(".ringbuilder-tab__diamond").hasClass("loaded")){
            if($(".ringbuilder-diamonds__total__number").text() !== "0" && !scroll_lock){
                if($(window).scrollTop() + $(window).height() > $(".ringbuilder__diamonds__offset-trigger").offset().top){
                    if($(".ringbuilder__diamond").length < parseInt($(".ringbuilder-diamonds__total__number").text().replace(",","").replace(".",""))){
                        $(".ringbuilder-tab__diamond").removeClass("loaded")
                        $(".ringbuilder-tab__diamond").attr('data-offset', parseInt($(".ringbuilder-tab__diamond").attr('data-offset')) + 20);
                        useFilters(true);
                    }
                }
            }
        }
    });

    const filterShapes = (shapes_array) => {
        let filtered_shapes = [];
        shapes_array.forEach(item => {
            if(item == "CUSHION"){
                filtered_shapes.push("CUSHION", "CUSHION_BRILLIANT", "CUSHION_MODIFIED", "CUSHION BRILLIANT", "CUSHION MODIFIED");
            } else {
                filtered_shapes.push(item);
            }
        });
        // console.log("Shapes array", filtered_shapes);
        return filtered_shapes;
    }

    const default_body = {
        colors: ["L", "K", "J", "I", "H", "G", "F", "E", "D"],
        carat: {from: 0, to: 30.00},
        clarity: ["SI2","SI1","VS2","VS1","VVS2","VVS1","IF","FL"],
        cut: ["GD","VG","EX","ID"],
        offset: 0,
        labgrown: TYPE_OF_DIAMOND == "nat" ? false : true,
        has_image: false,
        shapes: filterShapes(ALLOWED_SHAPES.map(shape => shape.toUpperCase().trim())),
        certificate: ["IGI","HRD","GIA"],
        polish: ["GD","VG","EX","FR"],
        symmetry: ["GD","VG","EX","FR"],
        fluorescence: ["VST","STG","MED","FNT","NON"],
        ratio: {from: 0.9, to: 2.5},
        table: {from: 40.00, to: 80.00},
        depth: {from: 40.00, to: 100.00}
    };

    const useFilters = async (append = false) => {
        if(!append){
            cursor = null;
            hasNextPage = false;
        }
        await setTimeout(async () => {
            const body = {};
            body.colors = $(".ringbuilder__slider__color-options .ringbuilder__slider__option.selected").toArray().map(item => item.innerText);
            body.carat = {from: parseFloat($(".ringbuilder__carat__min option:selected").attr("value")), to: parseFloat($(".ringbuilder__carat__max option:selected").attr("value"))};
            body.clarity = $(".ringbuilder__slider__clarity-options .ringbuilder__slider__option.selected").toArray().map(item => item.innerText);
            body.cut = $(".ringbuilder__slider__cut-options .ringbuilder__slider__option.selected").toArray().map(item => $(item).attr("data-value"));
            body.price = {from: parseFloat($(".ringbuilder__price__min").val()), to: parseFloat($(".ringbuilder__price__max").val())};
            body.offset = $(".ringbuilder-tab__diamond").attr('data-offset');
            body.has_image = $(".ringbuilder-diamonds__image-filter__checkbox").is(":checked");
            body.labgrown = TYPE_OF_DIAMOND == "nat" ? false : true;
            body.shapes = filterShapes($(".ringbuilder__shape.active").length ? $(".ringbuilder__shape.active").toArray().map(item => $(item).attr("data-shape").toUpperCase().trim()) : $(".ringbuilder__shape:not(.disabled)").toArray().map(item => $(item).attr("data-shape").toUpperCase().trim()));
    
            // ADVANCED
            body.certificate = $(".certificate__filter input:checked").length ? $(".certificate__filter input:checked").toArray().map(item => $(item).attr('name').toUpperCase()) : $(".certificate__filter input").toArray().map(item => $(item).attr('name').toUpperCase())
            body.polish = $(".polish__filter .ringbuilder__slider__option.selected").toArray().map(item => $(item).attr('data-value').toUpperCase())
            body.symmetry = $(".symmetry__filter .ringbuilder__slider__option.selected").toArray().map(item => $(item).attr('data-value').toUpperCase())
            body.fluorescence = $(".fluorescence__filter input:checked").length ? $(".fluorescence__filter input:checked").toArray().map(item => $(item).attr('name').toUpperCase()) : $(".fluorescence__filter input").toArray().map(item => $(item).attr('name').toUpperCase())
            body.ratio = {from: parseFloat($(".ratio__filter .ringbuilder__min").val()), to: parseFloat($(".ratio__filter .ringbuilder__max").val())};
            body.table = {from: parseFloat($(".table__filter .ringbuilder__min").val()), to: parseFloat($(".table__filter .ringbuilder__max").val())};
            body.depth = {from: parseFloat($(".depth__filter .ringbuilder__min").val()), to: parseFloat($(".depth__filter .ringbuilder__max").val())};
            if(append) body.cursor = cursor;
            console.log(body);
            
            await getDiamonds(JSON.stringify(body), append);

            scroll_lock = false;
        }, 1000);
    }

    // const getExchangeRates = async () => {
    //     const resp = await (await fetch("/apps/ringbuilder/exchange_rates")).json();
    //     return resp;
    // };

    (async () => {
        try{
        //   const data = await getExchangeRates();
      
        //   const eur = data.data.get_exchange_rates.filter(item => item.name == "EUR")[0];
      
        //   exchange_rates = {to_USD : eur.to_USD, to_EUR: 1 / eur.to_USD};
      
          await getPriceRange(JSON.stringify(default_body));
      
          default_body.price = {from: parseFloat($(".ringbuilder__price__min").val()), to: parseFloat($(".ringbuilder__price__max").val())};
          
          console.log("Default body", default_body);
          await getDiamonds(JSON.stringify(default_body));
        } catch(error) {
          console.error(error);
        }
    })();

    // MOBILE

    $(".ringbuilder__control").on("click", function(){
        const selected = $(this).text().trim().toLowerCase();
        currentFilter = $(`.ringbuilder-diamonds__filter__${selected}`);
        $(`.ringbuilder-diamonds__filter__${selected}`).fadeIn(200);
        $(`.ringbuilder-diamonds__blured-bg`).fadeIn(200, function(){
            updateSliders();
        });
        $("body").css("overflow", "hidden");
    });

     $(".ringbuilder-diamonds__blured-bg").on("click", function(){
        if($(window).width() <= 800 && currentFilter.css('display') === 'block'){
            closeFilter();
        }
        else {
          $(".ringbuilder-diamonds__popup").fadeOut(200);
          $(".ringbuilder-diamonds__blured-bg").fadeOut(200);
          if($(".rigbuilder__size-selector").hasClass("shown")){
              $(".rigbuilder__size-selector").removeClass("shown");
          }
          $("body").css("overflow","auto");
          if($(window).width() <= 800){
              $(`.ringbuilder-diamonds__blured-bg`).fadeIn(200);
              currentFilter.fadeIn(200);
          }
          setTimeout(function() { 
         currentFilter.parent().addClass("active");  
    }, 500);
      }
    });

    $(".ringbuilder-diamonds__filters__close").on("click", function(){
        if($(window).width() <= 800){
            closeFilter();
        }
    });

    $(".ringbuilder__filter__apply, .ringbuilder__filter__shape__apply").on("click", function(){
        $(".ringbuilder-tab__diamond").attr('data-offset', 0);
        $(".ringbuilder-tab__diamond").removeClass("loaded");
        $(".ringbuilder__diamonds").html("");
        useFilters();
        closeFilter();
    });

    $(".ringbuilder-diamonds__filters__clear").on("click", function(){
        // console.log("Clearing");
        const parent = $(this).closest(".ringbuilder-diamonds__filters__cell, .ringbuilder-diamonds__advanced__filter__dropdown");
        const slider = parent.find(".ringbuilder__slider");
        const slider_inner = parent.find(".ringbuilder__slider__inner, .ringbuilder__carat__slider__inner, .ringbuilder__price__slider__inner");
        slider_inner.css({left: 0, right: 0});
        if(slider.attr("data-bounds")){
            const bounds = JSON.parse(slider.attr("data-bounds"));
            slider.next().attr('data-start', 0).attr('data-end', bounds.length - 1);
            
            calculateActiveSections(slider.next().find(".ringbuilder__slider__option"), 0, bounds.length - 1);
            calculateActiveSections(slider.find(".ringbuilder__slider__section"), 0, bounds.length - 1);
        }

        parent.find("input.ringbuilder__min").val(parent.find("input.ringbuilder__min").attr("min"));
        parent.find("input.ringbuilder__max").val(parent.find("input.ringbuilder__max").attr("max"));

        parent.find(".ringbuilder-diamonds__advanced__filter__checkbox").removeClass("active");
        parent.find(".ringbuilder-diamonds__advanced__filter__checkbox input").prop("checked", false);

        parent.find(".ringbuilder__carat__min option:first-child").prop('selected', true);
        parent.find(".ringbuilder__carat__max option:last-child").prop('selected', true);
        parent.find(".ringbuilder__price__min option:first-child").prop('selected', true);
        parent.find(".ringbuilder__price__max option:last-child").prop('selected', true);

        parent.find(".ringbuilder__shape.active").removeClass("active");
    });

    $(".ringbuilder__carat__min").on("change", function(){
        const length_of_options = $(this).find("option").length;
        const percent_per_step = 100 / length_of_options;
        const dot_width = $(".ringbuilder__carat__slider__dot").outerWidth(true);
        const bar_width = $(".ringbuilder-diamonds__filter__carat .ringbuilder__carat__slider").outerWidth(true);
        const one_percent = bar_width / 100;
        const val = $(this).val();
        let selected_index = false;
        $(this).find("option").each(function(i){
            if(parseFloat($(this).text()) == parseFloat(val)) selected_index = i;
        });
        if(selected_index === false) return;
        const total_percents = selected_index * percent_per_step;
        const percent_limit = (bar_width - dot_width) / one_percent;
        const final_value = total_percents > percent_limit ? percent_limit : total_percents;
        $(".ringbuilder__carat__slider__inner").css("left", `${final_value}%`);
        if(parseFloat($(".ringbuilder__carat__max").val()) < parseFloat(val)){
            $(".ringbuilder__carat__max").val(val).trigger("change");
        }
    });

    $(".ringbuilder__carat__max").on("change", function(){
        const length_of_options = $(this).find("option").length;
        const percent_per_step = 100 / length_of_options;
        const dot_width = $(".ringbuilder__carat__slider__dot").outerWidth(true);
        const bar_width = $(".ringbuilder-diamonds__filter__carat .ringbuilder__carat__slider").outerWidth(true);
        const one_percent = bar_width / 100;
        const val = $(this).val();
        let selected_index = false;
        $(this).find("option").each(function(i){
            if(parseFloat($(this).text()) == parseFloat(val)) selected_index = i;
        });
        if(selected_index === false) return;
        const total_percents = (selected_index + 1) * percent_per_step;
        const percent_limit = (bar_width - dot_width) / one_percent;
        const final_value = 100 - total_percents > percent_limit ? percent_limit : 100 - total_percents;
        console.log(selected_index, total_percents);
        
        $(".ringbuilder__carat__slider__inner").css("right", `${final_value}%`);
        if(parseFloat($(".ringbuilder__carat__min").val()) > parseFloat(val)){
            $(".ringbuilder__carat__min").val(val).trigger("change");
        }
    });

    $(".ringbuilder__price__min").on("change", function(){
        const length_of_options = $(this).find("option").length;
        const percent_per_step = 100 / length_of_options;
        const dot_width = $(".ringbuilder__price__slider__dot").outerWidth(true);
        const bar_width = $(".ringbuilder-diamonds__filter__carat .ringbuilder__price__slider").outerWidth(true);
        const one_percent = bar_width / 100;
        const val = $(this).val();
        let selected_index = false;
        $(this).find("option").each(function(i){
            if(parseFloat($(this).text()) == parseFloat(val)) selected_index = i;
        });
        if(selected_index === false) return;
        const total_percents = selected_index * percent_per_step;
        const percent_limit = (bar_width - dot_width) / one_percent;
        const final_value = total_percents > percent_limit ? percent_limit : total_percents;
        $(".ringbuilder__price__slider__inner").css("left", `${final_value}%`);
        if(parseFloat($(".ringbuilder__price__max").val()) < parseFloat(val)){
            $(".ringbuilder__price__max").val(val).trigger("change");
        }
    });

    $(".ringbuilder__price__max").on("change", function(){
        const length_of_options = $(this).find("option").length;
        const percent_per_step = 100 / length_of_options;
        const dot_width = $(".ringbuilder__price__slider__dot").outerWidth(true);
        const bar_width = $(".ringbuilder-diamonds__filter__carat .ringbuilder__price__slider").outerWidth(true);
        const one_percent = bar_width / 100;
        const val = $(this).val();
        let selected_index = false;
        $(this).find("option").each(function(i){
            if(parseFloat($(this).text()) == parseFloat(val)) selected_index = i;
        });
        if(selected_index === false) return;
        const total_percents = (selected_index + 1) * percent_per_step;
        const percent_limit = (bar_width - dot_width) / one_percent;
        const final_value = 100 - total_percents > percent_limit ? percent_limit : 100 - total_percents;
        console.log(selected_index, total_percents);
        
        $(".ringbuilder__price__slider__inner").css("right", `${final_value}%`);
        if(parseFloat($(".ringbuilder__price__min").val()) > parseFloat(val)){
            $(".ringbuilder__price__min").val(val).trigger("change");
        }
    });

    const closeFilter = () => {
        $("body").css("overflow", "auto");
        $(".ringbuilder-diamonds__filters__cell").fadeOut(200);
        $(".ringbuilder-diamonds__advanced__filter__dropdown").fadeOut(200, ()=>{
            $(".ringbuilder-diamonds__advanced__filter").removeClass("active");
            $(".ringbuilder-diamonds__advanced__filter__dropdown").attr("style", "");
        })
        $(".ringbuilder-diamonds__popup").fadeOut(200);
        $(".ringbuilder-diamonds__blured-bg").fadeOut(200);
    }

    const itemsNode = $('.final-stage__items')[0];
    const curPriceNode = $('.current_price')[0];

    const observerConfig = { 
        childList: true,   // Detect addition or removal of child nodes
        subtree: true,     // Also observe the children of the target node
        characterData: true // Observe changes to the text content of nodes
    };

    const totalCallback = function(mutationsList, observer) {
        console.log("====== UPDATING PRICE ON FINAL STAGE ======");
        console.log(`Ring price -> Unformatted (${$(".final-stage__item__price--ring").text()}) -> Formated (${$(".final-stage__item__price--ring").text().replace(/[^0-9.-]+/g,"")}) -> As a Number (${Number($(".final-stage__item__price--ring").text().replace(/[^0-9.-]+/g,""))}) `)
        const ring_price = Number($(".final-stage__item__price--ring").text().replace(/[^0-9.-]+/g,""));
        console.log(`Diamond price -> Unformatted (${$(".final-stage__item__price--diamond").text()}) -> Formated (${$(".final-stage__item__price--diamond").text().replace(/[^0-9.-]+/g,"")}) -> As a Number (${Number($(".final-stage__item__price--diamond").text().replace(/[^0-9.-]+/g,""))}) `)
        const diamond_price = Number($(".final-stage__item__price--diamond").text().replace(/[^0-9.-]+/g,""));
        console.log(`Total is: ${ring_price + diamond_price}`);
        const total = ring_price + diamond_price;
        $(".subtotal__amount, .total__amount").text(`$${total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`);
    };

    const curPriceCallback = function(mutationsList, observer){
      console.log(`Updating final ring price with ${$($(".ringbuilder-cols .current_price .money")[0]).text()}`);
      $(".final-stage__item__price--ring").text(`${$($(".ringbuilder-cols .current_price .money")[0]).text()} USD`);
    }

    // Create an observer instance linked to the callback function
    const totalObserver = new MutationObserver(totalCallback);
    const curPriceObserver = new MutationObserver(curPriceCallback);
    
    // Start observing the target node for configured mutations
    totalObserver.observe(itemsNode, observerConfig);
    curPriceObserver.observe(curPriceNode, observerConfig);

    // $(".final-stage__items").on("DOMSubtreeModified", function(){
    //     console.log("====== UPDATING PRICE ON FINAL STAGE ======");
    //     console.log("====== UPDATING PRICE ON FINAL STAGE ======");
    //     console.log("====== UPDATING PRICE ON FINAL STAGE ======");
    //     console.log(`Ring price -> Unformatted (${$(".final-stage__item__price--ring").text()}) -> Formated (${$(".final-stage__item__price--ring").text().replace(/[^0-9.-]+/g,"")}) -> As a Number (${Number($(".final-stage__item__price--ring").text().replace(/[^0-9.-]+/g,""))}) `)
    //     const ring_price = Number($(".final-stage__item__price--ring").text().replace(/[^0-9.-]+/g,""));
    //     console.log(`Diamond price -> Unformatted (${$(".final-stage__item__price--diamond").text()}) -> Formated (${$(".final-stage__item__price--diamond").text().replace(/[^0-9.-]+/g,"")}) -> As a Number (${Number($(".final-stage__item__price--diamond").text().replace(/[^0-9.-]+/g,""))}) `)
    //     const diamond_price = Number($(".final-stage__item__price--diamond").text().replace(/[^0-9.-]+/g,""));
    //     console.log(`Total is: ${ring_price + diamond_price}`);
    //     const total = ring_price + diamond_price;
    //     $(".subtotal__amount, .total__amount").text(`€${total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`);
    // });

    $(".final-stage__item__price--ring").text(`${$($(".ringbuilder-cols .current_price .money")[0]).text()} USD`);

    // $(".current_price").on("DOMSubtreeModified", function(){
    //     $(".final-stage__item__price--ring").text($($(".ringbuilder-cols .current_price .money")[0]).text());
    // });

    let dOne360;

    function addDiamondToSinglePage(){
        dOne360?.destroy();
        dOne360 = null;

        $(".ringbuilder__dOne__navigation__main").html("");
        $(".ringbuilder__dOne__image").html("");

        $(".ringbuilder__dOne__image").addClass("active");
        $(".ringbuilder__dOne__navigation__main").addClass("active");
        $(".ringbuilder__dOne__360").removeClass("active");
        $(".ringbuilder__dOne__navigation__360").removeClass("active");

        const json = JSON.parse(decodeURIComponent($(this).attr("data-json")));

        $(".ringbuilder__dOne__addToRing").attr("data-ref", $(this).attr("class").split(" ")[1]);

        const image = $(this).find(".ringbuilder__diamond__image img")[0]?.src ? $(this).find(".ringbuilder__diamond__image img")[0]?.src : $(this).find("img.ringbuilder__diamond__image").attr("src");
        // const images = $(this).find(".jsv-holder div:last-child img");

        $(".ringbuilder__dOne__navigation__360").show();

        const images = [];
        // console.log($(this));
        const frames = $(this).find(".jsv-holder").attr('data-frames');
        const url = $(this).find(".jsv-holder").attr('data-url');
        const top = $(this).find(".jsv-holder").attr('data-top');
        
        for (let i = 0; i < frames; i++) {
            if(top.length == 4){
                let push = "0000";
                if(`${i}`.length == 1) push = "000"+i;
                else if(`${i}`.length == 2) push = "00"+i;
                else if(`${i}`.length == 3) push = "0"+i;
                images.push(`${url}/${push}.jpg`);
            } else {
                images.push(`${url}/${i}.jpg`);
            }
        }

        if($(this).find(".jsv-holder").length == 0){
            $(".ringbuilder__dOne__navigation__360").hide();
        }

        $(".ringbuilder__dOne__navigation__main").html(`<img src="${image}">`);
        $(".ringbuilder__dOne__image").html(`<img src="${image}" alt="Main diamond image">`);

        const title = $(this).attr("data-small-name");
        const description = $(this).attr("data-description");
        const price = `${$(this).find(".ringbuilder__diamond__price").text().replace("\\n","").trim().split(" ")[0]} USD`;

        $(".ringbuilder__dOne__title").text(title);
        $(".ringbuilder__dOne__excerpt").text(description);
        $(".ringbuilder__dOne__price").text(price);

        $(".ringbuilder__dOne__360").html("");
        images.forEach(function(img){
            $(".ringbuilder__dOne__360").append(`<img src="${img}">`);
        });

        const json_keys = Object.keys(json);
        json_keys.forEach(key => {
            $(`.dOne-${key}`).text(json[key]);
        })
        
        const diamond_description = $(".ringbuilder__details__dropdown__content--diamond").html();
        $(".ringbuilder_diamond_description .drawer__row .rte").html(diamond_description);
    }

    function switchToDiamondPage(){
        $(".ringbuilder-tab__diamond-one").show();
        $(".ringbuilder-tab__diamond").hide();
        $(".section-complete-the-set-ringbuilder").removeClass("hidden");
        $(".ringbuilder_diamond_description").addClass("active");
        $(".ringbuilder_main_description").addClass("hidden");
        $(".ringbuilder-tab__ring").hide();
        $(".ringbuilder-tab__ring").removeClass("final");

        $(window).scrollTop($(".ringbuilder-navigation").offset().top - 20);
    }

    $(document).on("click", ".ringbuilder__diamond__more-info", function(e){
        switchToDiamondPage();
        addDiamondToSinglePage.call($(this.closest(".ringbuilder__diamond")));
    });

    $(".ringbuilder__details__dropdown__title").on("click", function(){
        const parent = $(this).parent();
        parent.find(".ringbuilder__details__dropdown__content").slideToggle(200);
        $(this).toggleClass("active");
    })

    $(".ringbuilder__dOne__navigation__main").on("click", function(){
        if(!$(this).hasClass("active")){
            $(".ringbuilder__dOne__image").addClass("active");
            $(".ringbuilder__dOne__navigation__main").addClass("active");
            $(".ringbuilder__dOne__360").removeClass("active");
            $(".ringbuilder__dOne__navigation__360").removeClass("active");
        }
    });

    $(".ringbuilder__dOne__navigation__360").on("click", function(){
        if(!$(this).hasClass("active")){
            $(".ringbuilder__dOne__image").removeClass("active");
            $(".ringbuilder__dOne__navigation__main").removeClass("active");
            $(".ringbuilder__dOne__360").addClass("active");
            $(".ringbuilder__dOne__navigation__360").addClass("active");
            if(!dOne360){
                const imageUrls = [];
                $(".ringbuilder__dOne__360 img").each(function(){
                    imageUrls.push($(this).attr("src"));
                });
                $($(".ringbuilder__dOne__360 img")[0]).attr("id", "ringbuilder__dOne__360__image");
                $(".ringbuilder__dOne__360").html($(".ringbuilder__dOne__360 img")[0]);
                dOne360 = new JavascriptViewer({
                    mainHolderId: "ringbuilder__dOne__360",
                    mainImageId: "ringbuilder__dOne__360__image",
                    imageUrls,
                    speed: 70,
                    defaultProgressBar: true
                });
                dOne360.start().then(() => {
                    dOne360.rotateDegrees(400).then(() => {
                        // continue with your amazing intro
                    })
                });
            }
        }
    });


    function addDiamondToFinalPage(){

        const img = $(this).find("img.ringbuilder__diamond__image").attr("src");
        const name = $(this).attr("data-small-name");
        const type = $(this).attr("data-description");
        const price = $(this).find(".ringbuilder__diamond__price").text().replace("\\n","").trim().split(" ")[0];
        const id = $(this).attr("data-id");

        $(".ringbuilder-navigation__step--diamond .ringbuilder-navigation__product__image").html(`<img src="${img}">`);
        $(".ringbuilder-navigation__step--diamond .ringbuilder-navigation__product__name").text(name);
        $(".ringbuilder-navigation__step--diamond .ringbuilder-navigation__product__description").text(type);
        $(".ringbuilder-navigation__step--diamond .ringbuilder-navigation__product__price").text(price);

        $(".ringbuilder-navigation__step.active").removeClass("active");    
        $(".ringbuilder-navigation__step--ring").addClass("done");
        $(".ringbuilder-navigation__step--diamond").addClass("done").removeClass("unmarked");
        $(".ringbuilder-navigation__step--final").addClass("active");
        $(".ringbuilder-tab__ring").show();
        $(".ringbuilder-tab__ring").addClass("final");
        $(".ringbuilder-tab__diamond").hide();
        $(".ringbuilder-tab__diamond-one").hide();

        $(".final-stage__diamond-description").text($(this).attr("data-description"));
        $(".final-stage__diamond-code").text("Code: "+$(this).attr("data-code"));
        $(".final-stage__item--diamond").attr("data-id", id);
        $(".final-stage__item__name--diamond").text($(this).attr("data-name"));
        $(".final-stage__item__price--diamond").text(`${$(this).find(".ringbuilder__diamond__price").text().replace("\\n","").trim().split(" ")[0]} USD`);

    }

    $(".ringbuilder__dOne__addToRing").on("click", function(){
        $(window).scrollTop($(".ringbuilder-navigation").offset().top - 20);
        if($(window).width() < 800){
            $(window).scrollTop(0);
        }
        parent = $(`.${$(this).attr("data-ref")}`);
        $(".ringbuilder-navigation__step--diamond").addClass("step__hover");
        $(".section-complete-the-set-ringbuilder").removeClass("hidden");
        $(".ringbuilder_main_description").addClass("hidden");
        $(".ringbuilder_diamond_description").removeClass("active");
        addDiamondToFinalPage.call(parent);
    });

    $(document).on("click", ".ringbuilder__diamond__add-diamond", function(e){
        e.stopPropagation();

        $(window).scrollTop($(".ringbuilder-navigation").offset().top - 20);
        if($(window).width() < 800){
            $(window).scrollTop(0);
        }

        const parent = $(this).closest(".ringbuilder__diamond");
        $(".ringbuilder-navigation__step--diamond").addClass("step__hover");
        $(".section-complete-the-set-ringbuilder").removeClass("hidden");
        $(".ringbuilder_main_description").addClass("hidden");
        $(".ringbuilder_diamond_description").removeClass("active");
        addDiamondToSinglePage.call(parent);
        addDiamondToFinalPage.call(parent);
    });

    $(document).on("click", ".final-stage__size", function(){
        $(".ringbuilder-diamonds__blured-bg").fadeIn(200);
        $(".rigbuilder__size-selector").addClass("shown");
        $("body").css("overflow","hidden");
    });

    $(document).on("click", ".ringbuilder__size-selector__close", function(){
        $(".ringbuilder-diamonds__blured-bg").fadeOut(200);
        $(".rigbuilder__size-selector").removeClass("shown");
        $("body").css("overflow","auto");
    });

    $(document).on("click", ".ringbuilder__select__selected", function(e){
        e.stopPropagation();

        const select = $(this).parent();

        select.toggleClass("active");
        select.find(".ringbuilder__select__list").slideToggle(200);
    });

    $(document).on("click", ".ringbuilder__select__list__item", function(e){
        e.stopPropagation();

        const select = $(this).closest(".ringbuilder__select__dropdown");

        const html = $(this).html();
        select.find(".ringbuilder__select__selected__inner").html(html);
        select.find(".ringbuilder__select__list__item.active").removeClass("active");
        $(this).addClass("active");
        const country_code = $(this).attr("data-country");

        // Switch active table
        if(select.hasClass("ef-item__size__country")){
            $(".ef-item__size__ringsize.shown").removeClass("shown");
            $(`.ef-item__size__ringsize.${country_code}`).addClass("shown");
            let selected_size = $(`.ef-item__size__ringsize.${country_code} .ringbuilder__select__selected .ringbuilder__select__name`).text();
            let selected_country = select.find(`.ringbuilder__select__selected .ringbuilder__select__name`).text();
            // Put in form
            $(".ef-item__size--country").val(selected_country).text(selected_country);
            $(".ef-item__size--size").val(selected_size).text(selected_size);
        }
        if(select.hasClass("ringbuilder__size__select")){
            $(".ringbuilder__size-selector__sizes-table.active").removeClass("active");
            $(`.ringbuilder__size-selector__sizes-table.${country_code}`).addClass("active");
        }
        if(select.hasClass("ef-item__size__ringsize")){
            let selected_size = select.find(`.ringbuilder__select__selected .ringbuilder__select__name`).text();
            // Put in form
            $(".ef-item__size--size").val(selected_size).text(selected_size);
        }

        // Close dropdown
        select.removeClass("active");
        select.find(".ringbuilder__select__list").slideUp(200);
    });

    $(document).on("click", ".ringbuilder__size-selector__sizes-table__cell", function(e){
        // Update hidden inputs and hide 
        if(!$(this).hasClass("empty")){
            $(".ringbuilder__size-selector__sizes-table__cell").removeClass("active");
            $(this).addClass("active")
            $(".final-stage__size").addClass("active");
            $(".final-stage__size .selected span").text($(this).text());
            
            $(".final-stage__size").attr("data-country", $(this).closest(".ringbuilder__size-selector__sizes-table").prev().find(".ringbuilder__select__selected .ringbuilder__select__name").text());
            $(".final-stage__size").attr("data-size", $(this).text());
    
            $(".ringbuilder-diamonds__blured-bg").fadeOut(200);
            $(".rigbuilder__size-selector").removeClass("shown");
            $("body").css("overflow","auto");
        }
    });

    let old_value = $(".swatch__header .swatch__value").text();
    // console.log("Swatch value element:", $(".swatch__header .swatch__value"));
    // console.log("Swatch value element:", JSON.stringify($(".swatch__header .swatch__value")[0]));
    // console.log("Swatch old value:", old_value);
    
    $(".swatch-element").on("mouseover", function(){
        $(".swatch__header .swatch__value").text($(this).find("input[type=radio]").attr('value'));
    });
    $(".swatch-element").on("mouseleave", function(){
        $(".swatch__header .swatch__value").text(old_value);
    });

    function loadImagesAndPerformActions(htmlString, callback = () => {}) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const imageElements = doc.querySelectorAll('img');
        
        // Collect all image URLs including those in srcset attributes
        const imageUrls = Array.from(imageElements).reduce((acc, img) => {
            if (img.src) acc.push(img.src);
            const srcset = img.getAttribute('srcset');
            if (srcset) {
                const urls = srcset.split(',').map(part => part.trim().split(' ')[0]);
                acc.push(...urls);
            }
            return acc;
        }, []);
    
        // Array to hold promises for image loading
        const loadPromises = imageUrls.map(url => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(url);
                img.onerror = () => reject(new Error(`Failed to load image at ${url}`));
                img.src = url;
            });
        });
    
        // Perform callback after all images are loaded
        Promise.all(loadPromises)
            .then(results => {
                console.log('All images loaded:', results);
                if (callback && typeof callback === 'function') {
                    callback();
                }
            })
            .catch(error => {
                console.error('Error loading one or more images:', error);
            });
    } 

    widgets.forEach(widget => {

    });

    $(".swatch__container input[type=radio]").on("click", function(){
        const id = $(this).attr("data-id");
        $(".product-data").attr("data-variant", id);
        $(".swatch-element").removeClass("active");
        $(this).closest(".swatch-element").addClass("active");
        $(`.single-option-selector`).val($(this).val()).trigger("change");
        $(".swatch__value").text($(this).val());
        $(".final-stage__ring-material").text($(this).val())
        const swatches = $(".swatch-element").toArray();
        let activate_widget_number = 0;
        let product_price = $(this).parent().attr("data-price");
        $(".ringbuilder-col .current_price .money").text(product_price);
        swatches.forEach((swatch, i) => {
            if($(swatch).find("input").is($(this))) activate_widget_number = i;
        });
        Magic360.stop();
        $(".ringbuilder-tab__ring .ringbuilder__diamonds__loader").removeClass("hidden");
        loadImagesAndPerformActions(widgets[activate_widget_number], () => {
            $(".magic_holder").html(widgets[activate_widget_number]);
            $(".MagicToolboxContainer").css("height", $(".magic_holder").css("height"));
            initMag360();
            old_value = $(".swatch__header .swatch__value").text();
            $(".ringbuilder-tab__ring .ringbuilder__diamonds__loader").addClass("hidden");
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('variant');
            currentUrl.searchParams.set('variant', id);
            const updatedUrl = currentUrl.toString();
            window.history.replaceState(null, '', updatedUrl);
        });
    });
    
    $(".ringbuilder-tab__ring .ringbuilder__diamonds__loader").addClass("hidden");
        // $(".ringbuilder-tab__ring .ringbuilder__diamonds__loader").addClass("hidden");

    const checkboxes = $(".ringbuilder-diamonds__advanced__filter__checkbox input[type=checkbox], .ringbuilder-diamonds__image-filter input[type=checkbox]");
    checkboxes.each(function(){
        $(this).after(`
            <div class="ringbuilder__custom-checkbox">
                <div class="ringbuilder__custom-checkbox__marker">
                    <svg fill="#000000" width="800px" height="800px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1743.858 267.012 710.747 1300.124 176.005 765.382 0 941.387l710.747 710.871 1209.24-1209.116z" fill-rule="evenodd"/>
                    </svg>
                </div>
            </div>
        `)
    });
    $(".ringbuilder__custom-checkbox").on("click", function(){
        const checked = $(this).prev().prop("checked");
        $(this).prev().prop("checked", !checked);
        $(this).prev().change();
        $(this).toggleClass("active");
    });

    $(window).resize(detectOutOfBounds);

let is_init = false;

function mtInitVariants() {
    if(!is_init){
        if (window.slate && slate.Variants && slate.Variants.prototype._updateImages) {
            slate.Variants.prototype._updateImagesOriginal = slate.Variants.prototype._updateImages;
            slate.Variants.prototype._updateImages = function(variant) {
                jQuery('.MagicToolboxSelectorsContainer a[data-variant-id*=",'+variant.id+',"]').trigger('click');
                return this._updateImagesOriginal.apply(this, arguments);
            };
        }
    
        if (Shopify.OptionSelectors && Shopify.OptionSelectors.prototype.updateSelectors) {
            Shopify.OptionSelectors.prototype.updateSelectorsOriginal = Shopify.OptionSelectors.prototype.updateSelectors;
            Shopify.OptionSelectors.prototype.updateSelectors = function(index, option) {
                var values = this.selectedValues(),
                    variant = this.product.getVariant(values);
                if (variant) {
                    jQuery('.MagicToolboxSelectorsContainer a[data-variant-id*=",'+variant.id+',"]').trigger('click');
                }
                return this.updateSelectorsOriginal.apply(this, arguments);
            }
        }
        is_init = true;
    }
}    

function mtOnDomReady(fnc) {
  if (typeof(jQuery) == 'undefined') {
    setTimeout(function() {
      mtOnDomReady(fnc);
    }, 250);
    return;
  }
  jQuery(document).ready(fnc);
}
})
})